"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserApprover {
    constructor(data) {
        if (data) {
            this.deserialize(data);
        }
    }
    deserialize(input) {
        this.limit = input.limit;
        this.approver = input.approver;
        this.currency = input.currency;
        return this;
    }
}
exports.default = UserApprover;
